import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import partners, { partnersSaga } from './partners';
import partner, { partnerSaga } from './partner';
import partnerFiles, { partnerFilesSaga } from './files';
import partnerEmployees, { partnerEmployeesSaga } from './employees';
import partnerProductPrices, { partnerProductPricesSaga } from './productprices';

const partnerModule = combineReducers({
  partners,
  partner,
  partnerFiles,
  partnerEmployees,
  partnerProductPrices,
});

export function* partnerModuleSaga() {
  yield all([
    partnersSaga(),
    partnerSaga(),
    partnerFilesSaga(),
    partnerEmployeesSaga(),
    partnerProductPricesSaga(),
  ]);
}

export default partnerModule;
